import { FC } from "react"
import { ContactSuccess } from "../../../module/systems/containers/contactSuccess"

export const ContactSuccessPage: FC = () => <ContactSuccess />
